import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import Box from '../../Box/index.esm.js';

var Fill = /*#__PURE__*/forwardRef(function (props, ref) {
  var index = props.index,
      isSingleHandle = props.isSingleHandle,
      rest = _objectWithoutPropertiesLoose(props, ["index", "isSingleHandle"]);

  var isPrimary = index === 1 && !isSingleHandle || index === 0 && isSingleHandle;
  return createElement(Box, _extends({
    ref: ref,
    height: "h-full",
    borderRadius: "rounded-full",
    cursor: "cursor-pointer",
    backgroundColor: isPrimary ? 'bg-blue-500' : 'bg-gray-200'
  }, rest));
});

export default Fill;
//# sourceMappingURL=index.esm.js.map
